"use client";

import { useSyncExternalStore } from "react";

/* The caption a buyer typed on a wall-art page, shared between the field,
 * the digital buy box and the framed-print panel without threading props
 * through server components. Per page load; never persisted. */
let text = "";
const listeners = new Set<() => void>();

export function setPersonalizeText(next: string): void {
  text = next;
  for (const l of listeners) l();
}
export function getPersonalizeText(): string {
  return text;
}
const subscribe = (cb: () => void) => {
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
  };
};
const getServer = () => "";
export function usePersonalizeText(): string {
  return useSyncExternalStore(subscribe, getPersonalizeText, getServer);
}
